import _ from "lodash";
import React from "react";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { Button } from "@components/Button";
import { Audio } from "@components/PreviewComponents/Audio";
import { Image } from "@components/PreviewComponents/Image";
import { ScrollingText } from "@components/PreviewComponents/ScrollingText";
import { Website } from "@components/PreviewComponents/Website";
import { YoutubeLive } from "@components/PreviewComponents/YoutubeLive";
import { Text } from "@components/Text";
import { COLOR_BLACK, COLOR_GREEN } from "@static/COLORS";
const { REACT_APP_API_ENDPOINT } = process.env;

const Container = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 2px;
`;

const InnerContainer = styled.div`
  /* display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1; */
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-bottom: 8px;
  background-color: rgba(0, 0, 0, 0.1);
`;

const GroupCampaign = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const GroupMedia = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  overflow: scroll;
`;

const MediaItem = styled.div`
  width: 140px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
`;

const GroupAction = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const FormCurrentCampaign = ({
  campaignList,
  customerId,
  locationId,
}) => {
  const navigate = useNavigate();

  const onHandleRedirect = ({ item }) => {
    console.log("item :>> ", item);
    const campaign_id = _.get(item, ["id"]);
    const campaign_name = _.get(item, ["name"]);
    const campaign_width = _.get(item, ["width"]);
    const campaign_height = _.get(item, ["height"]);
    const campaign_start_date = _.get(item, ["start_date"]);
    const campaign_end_date = _.get(item, ["end_date"]);

    // const adsBlocks = _.get(item, ["adsBlocks"], []);
    const adsBlocks = _.chain(item)
      .get(["adsBlocks"], [])
      .map((adsBlockItem) => {
        const blockMedias = _.get(adsBlockItem, ["blockMedias"]);
        const updateBlockMedias = _.map(blockMedias, (blockMediaItem) => {
          return _.omit(blockMediaItem, ["media"]);
        });
        return { ...adsBlockItem, blockMedias: updateBlockMedias };
      })
      .value();

    const widgets = _.chain(item).get(["widgets"], []).value();
    navigate("/campaign-blocks", {
      state: {
        customerId,
        locationId,
        campaign_id,
        campaign_name,
        campaign_width,
        campaign_height,
        campaign_start_date,
        campaign_end_date,
        adsBlocks,
        widgets,
      },
    });
  };
  return (
    <Container>
      <InnerContainer style={{ overflow: "scroll" }}>
        <Line />
        {_.map(campaignList, (item, index) => {
          return (
            <GroupCampaign key={index}>
              <GroupAction>
                <Text color={COLOR_BLACK} fontSize={"16px"} fontWeight="500">
                  Campaign: {_.get(item, ["name"])}
                </Text>
                <Button
                  type="button"
                  padding="0px"
                  onClick={() => onHandleRedirect({ item })}
                >
                  <Text color={COLOR_GREEN} fontSize={"16px"} fontWeight="500">
                    Go to campaign
                  </Text>
                </Button>
              </GroupAction>
              {/* 8:00 - 23:00 */}
              <GroupMedia>
                {_.chain(item)
                  .get(["adsBlocks"])
                  .flatMap("blockMedias")
                  .map((mediaItem, mediaIndex) => {
                    console.log("mediaItem :>> ", mediaItem);
                    const type = _.get(mediaItem, ["type"]);
                    const attribute = _.get(mediaItem, ["attribute"]);
                    const id = _.get(mediaItem, ["media", "id"]);
                    const thumbnailPath = _.get(mediaItem, [
                      "media",
                      "thumbnail_path",
                    ]);
                    const thumbnail = `${REACT_APP_API_ENDPOINT}/${thumbnailPath}`;
                    const path = `${REACT_APP_API_ENDPOINT}/${_.get(attribute, [
                      "path",
                    ])}`;

                    return (
                      <MediaItem key={mediaIndex}>
                        {(() => {
                          switch (type) {
                            case "image":
                              return <Image key={id} attribute={attribute} />;
                            case "video":
                              return (
                                <ReactPlayer
                                  key={id}
                                  url={path}
                                  controls
                                  width={"100%"}
                                  height={"100%"}
                                  light={
                                    thumbnailPath === null ? true : thumbnail
                                  }
                                  style={{
                                    background: COLOR_BLACK,
                                  }}
                                />
                              );
                            case "audio":
                              return (
                                <Audio
                                  key={id}
                                  attribute={attribute}
                                  playing={false}
                                />
                              );
                            case "website":
                              return <Website key={id} attribute={attribute} />;
                            case "youtube-live":
                              return (
                                <YoutubeLive
                                  key={id}
                                  attribute={attribute}
                                  width={120}
                                  height={80}
                                  playing={false}
                                />
                              );
                            case "running-text":
                              return (
                                <ScrollingText key={id} attribute={attribute} />
                              );

                            default:
                              return null;
                          }
                        })()}
                      </MediaItem>
                    );
                  })
                  .value()}
              </GroupMedia>
              <Line style={{ margin: "16px 0px" }} />
            </GroupCampaign>
          );
        })}
      </InnerContainer>
    </Container>
  );
};
